const getters = {
  getUsers: (state) => state.users,
  getUserRoles: (state) => state.userRoles
};

export default {
  getters
};
